export default {
  sex: {
    0: '未知',
    1: '男',
    2: '女'
  },
  isbind: {
    0: '未注册',
    1: '已注册'
  },
  subscribe: {
    0: '未关注',
    1: '已关注'
  },
  month: [1,2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  icon: {
    其他事件: 'more',
    积分事件: 'point',
    标签事件: 'point',
    用户信息事件: 'user',
    阅读文章事件: 'read',
    功能事件: 'set',
    活动事件: 'act'
  },
  type: {
    nickname: '用户名',
    leader_name: '直属领导',
  },
  clientType: {
    company: '客户公司名称',
    brand: '品牌',
    name: '联系人姓名',
    phone: '联系人电话',
  },
  vendorType: {
    vendor: '供应商名称',
    name: '联系人姓名',
    phone: '联系人电话',
  },
  proType: {
    invoice_no: '发票号码',
    invoice_code: '发票代码',
    contract_no: '合同编号',
    client_company: '客户公司名称',
    brand: '品牌',
    contract_name: '项目名称',
    invoice_amount: '开票金额',
    amount: '计划收款金额',
    manager_name: '项目负责人',
  },
  pruchaseType: {
    contract_no: '供应商合同编号',
    vendor: '供应商名称',
    contract_name: '供应商合同名称',
    client_company: '客户公司名称',
    brand: '品牌',
    client_contract_name: '客户项目名称',
    client_contract_no: '客户合同编号',
  },
  payType: {
    contract_name: '项目名称',
    contract_no: '合同编号',
    client_company: '客户公司名称',
    brand: '品牌',
    // pay_info: '支出明细名称',
    plan_name: '付款计划名称',
    vendor: '供应商',
    service_info: '服务说明',
  },
  adminType: {
    contract_name: '行政项目名称',
    contract_no: '项目编号',
    manager_name: '项目负责人',
    service_info: '采购事由',
    plan_name: '支付计划名称',
    vendor: '供应商名称',
  },
  humanType: {
    contract_name: '人力资源项目名称',
    contract_no: '项目编号',
    manager_name: '项目负责人',
    service_info: '采购事由',
    plan_name: '支付计划名称',
    vendor: '供应商名称',
  },
  expenseType: {
    realname: '申请人',
  },
  vacationType: {
    realname: '休假员工',
  },
  stationeryType: {
    name: '物品名称',
  },
  assestType: {
    asset_name: '物品名称',
    asset_code: '物品编号',
    fixed_asset_no: '固定资产编号',
    receive_user: '领用人',
  },
  pubcaseType: {
    vendor_name: '供应商名称',
    card_desc: '刊例描述',
  },
  level: {
    1: '',
    2: 'HR',
    3: 'AE',
    4: 'PM',
    5: 'AM',
    6: '财务',
    7: '高管',
    8: 'HRM',
    9: '设计',
    10: '技术',
  },
  answer: {
    1: 'A',
    2: 'B',
    3: 'C',
    4: 'D'
  },
  status: {
    1: '启用',
    2: '停用'
  },
  status1: {
    0: '未审核',
    1: '审核通过',
    2: '审核不通过'
  },
  status2: {
    1: '公司',
    2: '个人',
  },
  pro_status: {
    1: '未开始',
    2: '进行中',
    3: '项目终止',
    4: '已完成',
    5: '已归档',
    6: '未提交',
  },
  pro_status_c: {
    1: {color: '#c0c4cc', word: '未开始',},
    2: {color: '#96b471', word: '进行中',},
    3: {color: '#f56c6c', word: '项目终止',},
    4: {color: '#000000', word: '已完成',},
    5: {color: '#5979b1', word: '已归档',},
    6: {color: '#c0c4af', word: '未提交',},
  },
  contract_type: {
    1: '单一合同',
    2: '框架合同',
    3: '补充合同',
  },
  invoice_status: {
    1: '未开票',
    2: '部分开票',
    3: '已开票',
  },
  invoice_update: {
    1: '正常',
    2: '作废',
  },
  invoice_update_c: {
    1: {color: '#000000', word: '正常',},
    2: {color: '#c0c4cc', word: '作废',},
  },
  is_receive: {
    1: '未收款',
    2: '已收款',
  },
  is_receive_apply: {
    0: '未收款',
    1: '未收款',
    2: '部分收款',
    3: '已收款',
  },
  is_bill_apply: {
    1: '已申请',
    2: '未申请',
  },
  invoice_type: {
    1: '增值税普通发票',
    2: '增值税专用发票',
    3: '形式发票',
  },
  category_type: {
    1: '设计服务费',
    2: '技术服务费',
    3: '咨询服务费',
    4: '服务费',
  },
  service_type: {
    1: '执行-项目抵扣',
    2: '执行-数据优化',
    3: '执行-认证服务',
    4: '执行-咨询服务',
    5: '技术-技术开发',
    6: '技术-技术服务',
    7: '设计-设计服务',
    8: '视频-视频制作',
    9: '媒体-媒体采购',
    10: '媒体-艺人合作',
    11: '媒体-达人合作',
    12: '媒体-媒体公关',
    13: '活动-舞美搭建',
    14: '活动-陈列搭建',
    15: '活动-视频直播',
    16: '销售-销售提成',
    17: '采购-印刷制作',
    18: '采购-道具制作',
    19: '采购-物品采购',
    20: '采购-周边制作',
    21: '劳务-劳务派遣',
    22: '劳务-劳务外包',
    23: '劳务-现金奖励',
    24: '劳务-技术外包',
    25: '劳务-设计外包',
    26: '劳务-摄影摄像',
    27: '劳务-演员合作',
    28: '劳务-专家合作',
    29: '劳务-节目表演',
    30: '版权-版权购买',
    31: '版权-版权合作',
    32: '租赁-技术租赁',
    33: '租赁-设备租赁',
    34: '租赁-场地租赁',
    35: '租赁-其他租赁',
    36: '租赁-仓库租赁',
    37: '其他-代付充值',
    38: '其他-酒店差旅',
    39: '其他-物流费用',
  },
  pay_type: {
    1: '正常',
    2: '预支'
  },
  pay_status: {
    1: '未支付',
    2: '部分支付',
    3: '已支付',
  },
  pay_status_c: {
    1: {color: '#c0c4cc', word: '未支付',},
    2: {color: '#ffc000', word: '部分支付',},
    3: {color: '#000000', word: '已支付',},
  },
  budget_status: {
    1: '未提交',
    2: '待审核',
    3: '审核通过',
    4: '审核不通过',
  },
  budget_status_c: {
    1: {color: '#c0c4cc', word: '未提交',},
    2: {color: '#ffc000', word: '待审核',},
    3: {color: '#96b471', word: '审核通过',},
    4: {color: '#f56c6c', word: '审核不通过',},
  },
  pay_check_status: {
    1: '未申请',
    2: '待审核',
    3: '审核通过',
    4: '审核不通过',
  },
  pay_check_status_c: {
    1: {color: '#c0c4cc', word: '未申请',},
    2: {color: '#ffc000', word: '待审核',},
    3: {color: '#96b471', word: '审核通过',},
    4: {color: '#f56c6c', word: '审核不通过',},
  },
  pruchase_contract_status: {
    1: '已申请',
    2: '已获取编号',
    3: '已盖章',
    4: '未申请',
    5: '未选择合同',
  },
  pruchase_contract_status_c: {
    1: {color: '#ffc000', word: '已申请',},
    2: {color: '#96b471', word: '已获取编号',},
    3: {color: '#000000', word: '已盖章',},
    4: {color: '#c0c4cc', word: '未申请',},
    5: {color: '#f56c6c', word: '未选择合同',},
    6: {color: '#7a2dd1', word: '无需合同',},
  },
  track_type: {
    0: '全部流程',
    1: '项目合同',
    2: '成本管理',
    3: '供应商合同',
    4: '支付管理',
    5: '发票管理',
    6: '项目收款',
    7: '项目状态',
    8: '项目补充',
    9: '预算管理',
    10: '行政管理',
    11: '人力资源管理',
    12: '报销管理',
  },
  expense_status: {
    0: '待报销',
    1: '已申请报销',
    2: '无报销',
  },
  expense_status_c: {
    0: {color: '#c0c4cc', word: '待报销',},
    1: {color: '#96b471', word: '已申请报销',},
    2: {color: '#000000', word: '无报销',},
  },
  leader_check_status: {
    0: '待提交',
    1: '待审核',
    2: '审核通过',
    3: '审核不通过',
  },
  leader_check_status_c: {
    0: {color: '#c0c4cc', word: '待提交',},
    1: {color: '#ffc000', word: '待审核',},
    2: {color: '#96b471', word: '审核通过',},
    3: {color: '#f56c6c', word: '审核不通过',},
  },
  finance_check_status: {
    0: '待主管审核',
    1: '待审核',
    2: '审核通过',
    3: '审核不通过',
  },
  finance_check_status_c: {
    0: {color: '#c0c4cc', word: '待主管审核',},
    1: {color: '#ffc000', word: '待审核',},
    2: {color: '#96b471', word: '审核通过',},
    3: {color: '#f56c6c', word: '审核不通过',},
  },
  agent_check_status: {
    0: '未确认',
    1: '确认通过',
    2: '不通过',
  },
  agent_check_status_c: {
    0: {color: '#c0c4cc', word: '未确认',},
    1: {color: '#96b471', word: '确认通过',},
    2: {color: '#f56c6c', word: '不通过',},
  },
  department: {
    1: 'ACCOUNT',
    2: 'CREATIVE',
    3: 'TECH',
    4: 'FINANCE',
    5: 'HR',
    6: 'MANAGEMENT',
  },
  asso_service_type: ['61','62','63','72','73','75','81'],
  holidayType: {
    1: '年假',
    2: '婚假',
    3: '产假',
    4: '陪产假',
    5: '调休',
    6: '事假',
    7: '病假',
    8: '丧假',
    11: '居家办公',
  },
  holidayStatus: {
    0: '未申请',
    1: '已申请',
  },
  holidayStatus_c: {
    0: {color: '#c0c4cc', word: '未申请',},
    1: {color: '#000000', word: '已申请',},
  },
  holidayUseStatus_c: {
    0: {color: '#c0c4cc', word: '正常',},
    1: {color: '#f56c6c', word: '休假中',},
  },
  holidayFutureStatus_c: {
    0: {color: '#c0c4cc', word: '未申请',},
    1: {color: '#ffc000', word: '待代理人审核',},
    2: {color: '#ffc000', word: '待主管审核',},
    3: {color: '#ffc000', word: '待人事审核',},
    4: {color: '#96b471', word: '已审核',},
  },
  assestStatus: {
    1: '正常',
    2: '维修',
    3: '过期',
    4: '部分过期',
  },
  assestStatus_c: {
    1: {color: '#96b471', word: '正常',},
    2: {color: '#c0c4cc', word: '维修',},
    3: {color: '#f56c6c', word: '过期',},
    4: {color: '#ffc000', word: '部分过期',},
  },
  assestbelong_type: {
    1: '公司',
    2: '项目',
  },
  assestStayStatus: {
    0: '暂无',
    1: '正常',
    3: '报废',
    4: '部分报废',
  },
  assestStayStatus_c: {
    0: {color: '#c0c4cc', word: '暂无',},
    1: {color: '#96b471', word: '正常',},
    3: {color: '#f56c6c', word: '报废',},
    4: {color: '#ffc000', word: '部分报废',},
  },
  assestUseStatus: {
    0: '在库',
    1: '领用',
    2: '部分领用'
  },
  assestUseStatus_c: {
    0: {color: '#96b471', word: '在库',},
    1: {color: '#000000', word: '领用',},
    2: {color: '#5979b1', word: '部分领用',},
  },
  size: {
    0: {
      w: '0',
      h: '0'
    },
    1: {
      w: '334',
      h: '85'
    },
    2: {
      w: '100',
      h: '100'
    },
    3: {
      w: '-',
      h: '-'
    },
    4: {
      w: '-',
      h: '-'
    },
    5: {
      w: '100',
      h: '100'
    },
    6: {
      w: '310',
      h: '400'
    },
    7: {
      w: '100',
      h: '100'
    },
    8: {
      w: '280',
      h: '160'
    },
    9: {
      w: '295',
      h: '80'
    },
    10: {
      w: '335',
      h: '380'
    },
    11: {
      w: '325',
      h: '445'
    },
    12: {
      w: '351',
      h: '146'
    }
  },
  color_pan: {
    0: {color: '#d40000', word: '',},
    1: {color: '#ff6565', word: '',},
    2: {color: '#ffaf42', word: '',},
    3: {color: '#feeb39', word: '',},  
    4: {color: '#59ff71', word: '',},  
    5: {color: '#047c3c', word: '',},  
    6: {color: '#3d93fa', word: '',},  
    7: {color: '#3946ac', word: '',},  
    8: {color: '#d571ff', word: '',},  
    9: {color: '#ab90dd', word: '',},  
    10: {color: '#9d8f82', word: '',},  
    11: {color: '#6f4a41', word: '',},  
  }
}
